import AppRoutes from 'src/AppRoutes';

export type RewardType = {
  points: number;
  additionalpoints: number;
  additionalPoints?: number;
  redeemvalue: number;
  redeemValue?: number;
};

export type RewardCashType = {
  rewardCashId: string;
  rewardProgramId: string;
  pointsRequired: number;
  cashAmount: number;
  tierLevel: number;
  isDisabled: boolean;
  dateCreated: string;
  lastUpdated: string;
  type: RewardItemType;
};

export type RewardProductType = {
  rewardProductId: string;
  productId: string;
  upc: Array<string>;
  name: string;
  imageUrl: string;
  type: RewardItemType;
};

export enum RewardItemType {
  PRODUCT = 'PRODUCT',
  CASH = 'CASH',
}

export enum RewardPolicyType {
  ADD_CREDIT_CARD = '100',
  LOAD_WALLET_MIN_AMOUNT = '101',
  ADD_BIRTHDAY = '102',
  AUTO_RELOAD = '103',
  APP_SURVEY = '104',
  PURCHASE_STREAK = '105',
  COME_BACK_SOON = '106',
  MIN_SPEND = '107',
  ADD_PHONE_NUMBER = '108',
}

type RewardsParams = {
  refreshRewards?: boolean;
  suppressRedirect?: boolean;
};
export type MainConsumerParamList = {
  [AppRoutes.RewardsScreen]: RewardsParams | undefined;
};
